var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"external-tile-data-overlay"},_vm._l((_vm.entries),function(t){return _c('div',{key:_vm.Id(t)},_vm._l((_vm.areaLayer(t)),function(a){return _c('AreaLayer',{key:_vm.Id(a),attrs:{"area":a.area,"color":a.color}})}),1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }